import { useIpidLink, useProductTexts, useUrls } from "Store/texts/hooks";
import React, { useState } from "react";
import { ButtonContainer } from "./styled";

import { insuranceNameToProductBackendName } from "Components/Features/CheckPrice/Products/utils";
import { RemoveProductsModal } from "Components/InsuranceDetailsCard/EditableInsuranceDetailsCard/RemoveProductDrawer";
import { FooterProductDetails } from "Components/InsuranceDetailsCard/FooterProductDetails";
import { getProductDetailsList } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/utils";
import { useTexts } from "Components/TextContext";
import { useIsAdviceProduct } from "Store/advice/hooks";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { buttonDetailsTrackId } from "Utils/analytics";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import { FooterContainer } from "../../styled";
import { EditButton } from "./EditButton";
import { ResponsiveButton } from "./editableCardFooterStyled";

interface Props {
  onRemoveProduct: (products: InsuranceProduct[]) => void;
  readonly product: InsuranceProduct;
  readonly additionalProduct?: InsuranceProduct;
}

export const EditableCardFooter = ({
  onRemoveProduct,
  product,
  additionalProduct,
}: Props): React.ReactElement => {
  const [showDetails, toggleDetails] = useState<boolean>(false);
  const [productText, lang] = useProductTexts(getFMSProductName(product.name));
  const featureToggleGeodata = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_1556_GEODATA_PM,
  );

  const isAdviceProduct = useIsAdviceProduct(product);
  const { getText } = useTexts();
  const [urls] = useUrls();
  const ipidLink = useIpidLink(product.coverageGroup);

  const productDetails = getProductDetailsList(
    product,
    productText.types,
    lang,
    urls,
    featureToggleGeodata,
  );
  const productBackendName = insuranceNameToProductBackendName(product.name);
  const hasDetails =
    productDetails.length > 0 || !!ipidLink || !!productBackendName;

  const handleToggleDetails = (): void => {
    toggleDetails(!showDetails);
  };

  const removeProductsInterceptor = (
    productsToRemove: InsuranceProduct[],
  ): void => {
    onRemoveProduct(productsToRemove);
  };

  return (
    <FooterContainer className="insurance-details-card__footer">
      <ButtonContainer>
        <EditButton product={product} />
        <ResponsiveButton
          variant="text"
          trackId={buttonDetailsTrackId("editable")}
          onClick={handleToggleDetails}
          hidden={!hasDetails}
          iconRight={showDetails ? "chevron-up" : "chevron-down"}
        >
          {getText("insurancecard.button.details")}
        </ResponsiveButton>
        {!isAdviceProduct && (
          <RemoveProductsModal
            removeProductsInterceptor={removeProductsInterceptor}
            products={
              additionalProduct ? [product, additionalProduct] : [product]
            }
          />
        )}
      </ButtonContainer>

      <FooterProductDetails
        product={product}
        showDetails={showDetails}
        productDetails={productDetails}
      />
    </FooterContainer>
  );
};
